module.exports = __webpack_public_path__ + "static/media/Search Icon.804e99f3.svg";